/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { DeleteMonitorMutationResponse, DeleteMonitorPathParams, DeleteMonitor401, DeleteMonitor404 } from '../types/DeleteMonitor.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getDeleteMonitorUrl(id: DeleteMonitorPathParams['id']) {
  const res = { method: 'DELETE', url: `/v1/monitors/${id}` as const };
  return res;
}

/**
 * @summary Delete a monitor
 * {@link /v1/monitors/:id}
 */
export async function deleteMonitor(id: DeleteMonitorPathParams['id'], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<DeleteMonitorMutationResponse, ResponseErrorConfig<DeleteMonitor401 | DeleteMonitor404>, unknown>({
    method: 'DELETE',
    url: getDeleteMonitorUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
